(() => {
  function init() {
    const heading = document.querySelector('[data-kavieli-review-carousel] .kavieli-photo-reviews__heading');
    if (heading) {
      document.querySelectorAll('div.kavieli-reviews-badge').forEach((badge) => {
        if (badge.closest('a, .product-card')) return;
        const link = document.createElement('a');
        for (const attribute of badge.attributes) link.setAttribute(attribute.name, attribute.value);
        link.href = `#${heading.id}`;
        const reviewLabel = document.documentElement.lang.toLowerCase().startsWith('de') ? 'Kundenbewertungen lesen' : document.documentElement.lang.toLowerCase().startsWith('en') ? 'Read customer reviews' : 'Voir les avis clients';
        link.setAttribute('aria-label', `${badge.textContent.trim()} — ${reviewLabel}`);
        link.append(...badge.childNodes);
        badge.replaceWith(link);
        link.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = document.getElementById(link.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          const header = document.querySelector('header-component');
          const offset = (header?.getBoundingClientRect().height || 0) + 24;
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
          window.scrollTo({
            top: window.scrollY + target.getBoundingClientRect().top - offset,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        });
      });
    }
    document.querySelectorAll('[data-kavieli-review-carousel]').forEach((section) => {
      if (section.dataset.carouselReady) return;
      section.dataset.carouselReady = 'true';
      const track = section.querySelector('[data-review-track]');
      const firstCard = track && track.querySelector('.kavieli-photo-reviews__card');
      if (!track || !firstCard) return;
      const move = (direction) => {
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * (firstCard.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };
      section.querySelector('[data-review-prev]')?.addEventListener('click', () => move(-1));
      section.querySelector('[data-review-next]')?.addEventListener('click', () => move(1));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
